/**
 * @module support/shared/widgets / Components - Page title directive
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved
 */

// It is not considering import as declaration , throwing lint error at import statement itself

import { Directive, ElementRef, HostListener, Input, OnDestroy } from '@angular/core';
import { DeviceDetectionService } from '@support/shared/widgets/services/device-detection.service';
import { BorderHeight } from '@support/shared/widgets/interfaces/title-header-spacing.interface';

@Directive({
  selector: '[tmoTitleHeaderSpacing]',
})
export class TitleHeaderSpacingDirective implements OnDestroy {
  private el: ElementRef;
  private serv: DeviceDetectionService;
  private borderHeight: BorderHeight = { md: 1, sm: 0 };
  private desktopView: number = 991;
  private titleHeight: number = 0;

  /**
   * Use to calculate header spacing.
   * @returns boolean
   */
  @Input('calculateHeaderSpacing')
  public set calculateHeaderSpacing(value: boolean) {
    const rate = 0.1;
    if (value) {
      setTimeout(() => {
        this.setTitle();
      }, rate);
    }
  }

  constructor(el: ElementRef, serv: DeviceDetectionService) {
    this.el = el;
    this.serv = serv;
    const rate = 0.1;
    setTimeout(() => {
      this.setTitle();
    }, rate);
  }

  /**
   * Set the title for the widget
   * @returns void
   */
  public setTitle(): void {
    const titleElement = this.el.nativeElement.previousElementSibling;
    const borderSpace =
      window.innerWidth > this.desktopView ? this.borderHeight.md : this.borderHeight.sm;
    if (titleElement) {
      this.titleHeight = Number(titleElement.clientHeight) + borderSpace;
      this.el.nativeElement.style.height = this.titleHeight.toString().concat('px');
      const bodyElement = document.getElementsByTagName('body')[0];
      if (this.serv.isDesktop) {
        if (bodyElement.scrollHeight > bodyElement.clientHeight) {
          const bodyWidth = window.innerWidth;
          const scrollbarOffset = 9;
          const divisible = 2;
          titleElement.style.width = (bodyWidth - scrollbarOffset).toString().concat('px');
          titleElement.style.marginLeft = '-'
            .concat((bodyWidth / divisible).toString())
            .concat('px');
        }
      }
    }
  }

  @HostListener('window:resize', ['$event'])
  public onResize(event: string): void {
    this.setTitle();
  }

  /**
   * Destroys all the subscriptions.
   * @returns void
   */
  public ngOnDestroy(): void {}
}
